import { module } from 'modujs';
import Packery from 'packery'

export default class MasonryGrid extends module {

    static get settings() {
        return {
            ITEM_SELECTOR: '.b-masonry_item',
        }
    }

    constructor(m) {
        super(m);

        this.$container = this.$('container')[0]
    }

    init() {

        this.pkry = new Packery(this.$container, {
            itemSelector: MasonryGrid.settings.ITEM_SELECTOR,
            percentPosition: true,
        });
    }

    destroy() {
        if(this.pkry) {
            this.pkry.destroy()
        }
    }
}
